export const ForbiddenEmailDomains = [
    'hotmail.co.jp',
    'hotmail.com',
    'gmail.com',
    'infoseek.jp',
    'yahoo.com',
    'yahoo.co.jp',
    'livedoor.com',
    'mail.goo.ne.jp',
    'nifmail.jp',
    'excite.co.jp',
    'i.softbank.jp',
    'ezweb.ne.jp',
    'docomo.ne.jp',
    'icloud.com',
    'outlook.jp',
];
export const ForbiddenEmailDomainRegExps = ForbiddenEmailDomains.map((domain) => new RegExp(`${domain}$`));
